module.exports = __webpack_public_path__ + "media/images/login/login_t4_l-0a45b9e2e0f5c0a5e6f46b17d4702849.gif";